import { makeBooleanDataField, makeInt64DataField, makeStringDataField } from './DataFieldHelper';
function getFullFieldName(instanceName, fieldName) {
    return instanceName ? instanceName + '.' + fieldName : fieldName;
}
/**
 * Adds a data field from a contract to the data fields array.
 * If the data field value is empty, the field is skipped.
 * @param instanceName - The name of the contract instance. Empty if no instance.
 * @param fieldName - The name of the field to add
 * @param value - The value
 * @param dataFields - The array of data fields to which a field will be added
 */
function addStringDataField(dataFields, instanceName, fieldName, value, dataClassification) {
    if (dataClassification === void 0) { dataClassification = 4 /* DataClassification.SystemMetadata */; }
    if (value) {
        dataFields.push(makeStringDataField("".concat(getFullFieldName(instanceName, fieldName)), value, dataClassification));
    }
}
function addBooleanDataField(dataFields, instanceName, fieldName, value) {
    if (typeof value === 'boolean') {
        dataFields.push(makeBooleanDataField("".concat(getFullFieldName(instanceName, fieldName)), value));
    }
}
function addInt64DataField(dataFields, instanceName, fieldName, value) {
    if (typeof value === 'number') {
        dataFields.push(makeInt64DataField("".concat(getFullFieldName(instanceName, fieldName)), value));
    }
}
export var Result = {
    /* Gets data fields for the Office.System.Result contract */
    getFields: function (contract) {
        var instanceName = 'Activity.Result';
        var contractName = 'Office.System.Result';
        var dataFields = [];
        addInt64DataField(dataFields, instanceName, 'Code', contract.code);
        addStringDataField(dataFields, instanceName, 'Type', contract.type);
        addInt64DataField(dataFields, instanceName, 'Tag', contract.tag);
        addBooleanDataField(dataFields, instanceName, 'IsExpected', contract.isExpected);
        dataFields.push(makeStringDataField('zC.Activity.Result', contractName));
        return dataFields;
    }
}; // Result
export var Activity = {
    contractName: 'Office.System.Activity',
    /* Gets data fields for the Office.System.Activity contract */
    getFields: function (contract) {
        var instanceName = 'Activity';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'CV', contract.cV);
        addInt64DataField(dataFields, instanceName, 'Duration', contract.duration);
        addInt64DataField(dataFields, instanceName, 'Count', contract.count);
        addInt64DataField(dataFields, instanceName, 'AggMode', contract.aggMode);
        addBooleanDataField(dataFields, instanceName, 'Success', contract.success);
        if (contract.result) {
            dataFields.push.apply(dataFields, Result.getFields(contract.result));
        }
        dataFields.push(makeStringDataField('zC.Activity', this.contractName));
        return dataFields;
    }
}; // Activity
export var User = {
    /* Gets data fields for the Office.System.User contract */
    getFields: function (contract) {
        var instanceName = 'User';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'PrimaryIdentityHash', contract.primaryIdentityHash);
        addStringDataField(dataFields, instanceName, 'PrimaryIdentitySpace', contract.primaryIdentitySpace);
        addStringDataField(dataFields, instanceName, 'TenantId', contract.tenantId, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'TenantGroup', contract.tenantGroup, 1 /* DataClassification.EssentialServiceMetadata */);
        addBooleanDataField(dataFields, instanceName, 'IsAnonymous', contract.isAnonymous);
        return dataFields;
    }
}; // User
export var Funnel = {
    /* Gets data fields for the Office.System.Funnel contract */
    getFields: function (instanceName, contract) {
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'Name', contract.name);
        addStringDataField(dataFields, instanceName, 'State', contract.state);
        return dataFields;
    }
}; // Funnel
export var UserAction = {
    /* Gets data fields for the Office.System.UserAction contract */
    getFields: function (contract) {
        var instanceName = 'UserAction';
        var dataFields = [];
        addInt64DataField(dataFields, instanceName, 'Id', contract.id);
        addStringDataField(dataFields, instanceName, 'Name', contract.name);
        addStringDataField(dataFields, instanceName, 'CommandSurface', contract.commandSurface);
        addStringDataField(dataFields, instanceName, 'ParentName', contract.parentName);
        addStringDataField(dataFields, instanceName, 'TriggerMethod', contract.triggerMethod);
        addInt64DataField(dataFields, instanceName, 'TimeOffsetMs', contract.timeOffsetMs);
        return dataFields;
    }
}; // UserAction
export var App = {
    /* Gets data fields for the Office.System.App contract */
    getFields: function (contract) {
        var instanceName = 'App';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'Name', contract.name, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'Platform', contract.platform, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'Version', contract.version, 1 /* DataClassification.EssentialServiceMetadata */);
        return dataFields;
    }
}; // App
export var Session = {
    /* Gets data fields for the Office.System.Session contract */
    getFields: function (contract) {
        var instanceName = 'Session';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'Id', contract.id, 1 /* DataClassification.EssentialServiceMetadata */);
        addStringDataField(dataFields, instanceName, 'EcsETag', contract.ecsETag, 1 /* DataClassification.EssentialServiceMetadata */);
        return dataFields;
    }
}; // Session
export var HealthQosError = {
    /**
     * Gets data fields for the Health contract
     * See https://aka.ms/asha/docs for documentation on usage and parameters.
     * Generally, use sendHealthQosError() instead of using this contract directly.
     */
    getFields: function (contract) {
        var dataFields = [];
        dataFields.push(makeStringDataField('Pillar', contract.pillar));
        dataFields.push(makeStringDataField('Veto', contract.veto));
        dataFields.push(makeBooleanDataField('IsIntentional', contract.isIntentional));
        dataFields.push(makeBooleanDataField('IsInternal', contract.isInternal));
        dataFields.push(makeBooleanDataField('AlertOnPillar', contract.alertOnPillar));
        dataFields.push(makeBooleanDataField('IsSessionEndingError', contract.isSessionEndingError));
        addBooleanDataField(dataFields, undefined, 'InStaging', contract.inStaging);
        return dataFields;
    }
}; // HealthQosError
export var Release = {
    /* Gets data fields for the Office.System.Release contract */
    getFields: function (contract) {
        var instanceName = 'Release';
        var dataFields = [];
        addStringDataField(dataFields, instanceName, 'AudienceGroup', contract.audienceGroup, 1 /* DataClassification.EssentialServiceMetadata */);
        return dataFields;
    }
}; // Release
//# sourceMappingURL=Contracts.js.map